import { Box } from '@mui/material';
import React from 'react';
import MJPEG from './mjpeg.js';

function MJPEGPlayer({ url, id }: { url: string; id: string }) {
  React.useEffect(
    function initStream() {
      const player = new MJPEG.Player(id, url);
      player.start();
      return () => player.stop();
    },
    [url, id],
  );

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        bgcolor: 'black',
      }}
    >
      <Box component="canvas" id={id}>
        You need to enable JavaScript to run this app.
      </Box>
    </Box>
  );
}

export default MJPEGPlayer;
